module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cta-button",
    on: {
      "click": function($event) {
        _vm.scrollToSection('#map-and-feeds')
      }
    }
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "cta-button__stripes cta-button__stripes--left"
  }), _vm._v(" "), _c('div', {
    staticClass: "cta-button__stripes cta-button__stripes--right"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76a81e36","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CtaButton.vue
// module id = 174
// module chunks = 0